import "@/App.css";
import { BrowserRouter, Route, Routes, useLocation } from "react-router-dom";

import { ProtectedRoute } from "@/components/ProtectedRoute";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider } from "@/context/AuthContext";
import AdminDashboardPage from "@/pages/admin/AdminDashboard";
import AuthCallback from "@/pages/AuthCallback";
import AuthPage from "@/pages/AuthPage";
import CompleteProfile from "@/pages/CompleteProfile";
import Dashboard from "@/pages/Dashboard";
import LandingPage from "@/pages/LandingPage";
import PasswordResetPage from "@/pages/PasswordReset";
import NewRequest from "@/pages/patient/NewRequest";
import RequestView from "@/pages/patient/RequestView";
import ProRequestDetail from "@/pages/professional/ProRequestDetail";

function AppRouter() {
  const location = useLocation();
  // Detección síncrona del session_id de Google OAuth (debe procesarse ANTES que cualquier ruta)
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }
  return (
    <Routes>
      <Route path="/" element={<LandingPage />} />
      <Route path="/auth" element={<AuthPage />} />
      <Route path="/recuperar-contrasena" element={<PasswordResetPage mode="forgot" />} />
      <Route path="/restablecer-contrasena" element={<PasswordResetPage mode="reset" />} />
      <Route path="/completar-perfil" element={<CompleteProfile />} />
      <Route
        path="/dashboard"
        element={
          <ProtectedRoute>
            <Dashboard />
          </ProtectedRoute>
        }
      />
      <Route
        path="/nueva-solicitud"
        element={
          <ProtectedRoute roles={["patient"]}>
            <NewRequest />
          </ProtectedRoute>
        }
      />
      <Route
        path="/solicitud/:id"
        element={
          <ProtectedRoute roles={["patient", "admin"]}>
            <RequestView />
          </ProtectedRoute>
        }
      />
        <Route
          path="/pro/solicitud/:id"
          element={
            <ProtectedRoute roles={["professional", "admin"]}>
              <ProRequestDetail />
            </ProtectedRoute>
          }
        />
      <Route
        path="/admin"
        element={
          <ProtectedRoute roles={["admin"]}>
            <AdminDashboardPage />
          </ProtectedRoute>
        }
      />
    </Routes>
  );
}

export default function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <div className="App">
          <AppRouter />
        </div>
        <Toaster position="top-center" richColors />
      </AuthProvider>
    </BrowserRouter>
  );
}
